<template>
  <div class="input-container">
    <input
      type="radio"
      :name="'radio-' + $parent._uid"
      :id="'option-' + optionValue"
      :value="optionValue"
      @focus="onFocus"
      @blur="onBlur"
      @click="onClick"
      :checked="checked"
    />
    <label :for="'option-' + optionValue">{{ label }}</label>
  </div>
</template>

<script>
export default {
  name: "RadioItem",
  props: ["optionValue", "label", "name"],
  replace: false,
  data() {
    return {
      checked: ""
    };
  },
  methods: {
    getValue() {
      return this.optionValue;
    },
    setChecked() {
      this.checked = "checked";
    },
    onClick(val) {
      // Compatibilidad con Safari....
      if (this.$parent && this.$parent.onRadioClick) {
        this.$parent.onRadioClick(val.target.value);
      }
      this.$emit("input", val.target.value);
    },
    onFocus() {
      /* Animar viewport para que el elemento quede arriba
      70 = alto de topbar + padding */
      window.scroll({
        top: this.$el.offsetTop - 70,
        left: 0,
        behavior: "smooth"
      });
    },
    onBlur() {
      // Evento de interacción para GTM
      if (this.name) {
        this.gtmOnCheckboxBlur(this.name, this.checked);
      }
    }
  }
};
</script>

<style scoped>
.input-container {
  /* Quitar whitespace entre controles */
  font-size: 0;
}

/* https://stackoverflow.com/questions/26270168/how-to-customize-radio-button-in-html */
input[type="radio"] {
  /* remove standard background appearance */
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  /* create custom radiobutton appearance */
  display: inline-block;
  width: 24px;
  height: 24px;
  padding: 5px;
  /* background-color only for content */
  background-clip: content-box;
  border: 1px solid #666666;
  background-color: white;
  border-radius: 50%;
  margin-top: 0px;
  margin-right: 0;
  cursor: pointer;
  transition: all 0.2s ease-out;
}

label {
  cursor: pointer;
  display: inline-block;
  font-size: 15px;
  padding-left: 8px;

  font-family: "BentonSansBBVA-Book", Helvetica, Arial, sans-serif;
}

/* appearance for checked radiobutton */
input[type="radio"]:checked {
  background-color: #004481;
}

input[type="radio"]:focus {
  outline: none;
}

input[type="radio"]:checked + label {
  font-family: BentonSansBBVA-Medium;
}
</style>
